import useHoverLottie from "@/hooks/useHoverLottie";
import { useStore } from "@/stores";
import Lottie from "lottie-react";
import jiantou from "@/assets/lottie/jiantou.json";
import jiantou1 from "@/assets/lottie/jiantou.json";
import styles from "./index.module.less";
import { Flex } from "antd";
import p2Img from "./imgs/p2_img.png";
import p5Icon from "./imgs/p5_icon.png";
import p3Icon1 from "./imgs/p3_icon1.png";
import p3Icon2 from "./imgs/p3_icon2.png";
import p3Icon3 from "./imgs/p3_icon3.png";

import p4Img1 from "./imgs/p4_img1.png";
import p4Img2 from "./imgs/p4_img2.png";
import p4Img3 from "./imgs/p4_img3.png";
import p4Img4 from "./imgs/p4_img4.png";
import p6Icon1 from "./imgs/p6_icon1.png";
import p6Icon2 from "./imgs/p6_icon2.png";
import p6Icon3 from "./imgs/p6_icon3.png";
import p6Arrow from "./imgs/p6_arrow.svg";
import P1Content from "@/components/P1Content";
import p5CardBg from "./imgs/p5_card.svg";
import { p3List, p4List, p5List, p6Steps, data } from "./data";
import { isMobile } from "@/utils";
import MobileDeveloper from "./mobile";

const P5Card = ({
  title,
  list,
  link,
}: {
  title: string;
  list: string[];
  link: string;
}) => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: jiantou,
  });
  return (
    <div className={styles.p5_card}>
      <img src={p5CardBg} className={styles.p5_card_bg} />
      <div className={styles.p5_card_content}>
      <Flex gap={12} align="center" className={styles.p5_card_title}>
        <img src={p5Icon} className={styles.p5_card_icon} />
        {title}
      </Flex>
      <ul className={styles.p5_card_list}>
        {list.map((item, index) => (
          <li key={index} className={styles.p5_card_list_item}>
            {item}
          </li>
        ))}
      </ul>
      <div
        className={styles.p5_card_btn}
        onClick={() => {
          window.open(link, "_blank");
        }}
        onMouseEnter={playLottieOnce}
        onMouseLeave={stopLottie}
      >
        查看{title}接入文档
        <Lottie {...lottieOptions} className={styles.p5_card_btn_lottie} />
      </div></div>
    </div>
  );
};
const P3Card = ({
  title,
  list,
  icon,
  link,
}: {
  title: string;
  list: string[];
  icon: string;
  link?: string;
}) => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: jiantou,
  });
  const appStore = useStore("app");
  return (
    <div className={styles.p3_card}>
      <img className={styles.p3_card_icon} src={icon} />
      <div className={styles.p3_card_divider}></div>
      <div className={styles.p3_card_title}>{title}</div>
      <ul className={styles.p3_card_list}>
        {list.map((item, index) => (
          <li key={index} className={styles.p3_card_list_item}>
            {item}
          </li>
        ))}
      </ul>
      <div
        className={styles.p3_card_btn}
        onClick={() => {
          if (link) {
            window.open(link, "_blank");
          } else {
            appStore.openContactModal();
          }
        }}
        onMouseEnter={playLottieOnce}
        onMouseLeave={stopLottie}
      >
        {link ? "立即体验" : "联系我们"}
        <Lottie className={styles.p3_card_btn_lottie} {...lottieOptions} />
      </div>
    </div>
  );
};
const P4Card = ({
  title,
  desc,
  tags,
  img,
}: {
  title: string;
  desc: string;
  tags: string[];
  img: string;
}) => {
  return (
    <div className={styles.p4_card}>
      <Flex gap={".36rem"}>
        <img src={img} />
        <Flex vertical gap={".2rem"}>
          <div className={styles.p4_card_title}>{title}</div>
          <div className={styles.p4_card_desc}>{desc}</div>
          <div className={styles.p4_card_tags}>
            {tags.map((tag, index) => (
              <span key={index} className={styles.p4_card_tag}>
                {tag}
              </span>
            ))}
          </div>
        </Flex>
      </Flex>
    </div>
  );
};
const Developer = () => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: jiantou,
  });

  const {
    lottieOptions: lottieOptions1,
    playLottieOnce: playLottieOnce1,
    stopLottie: stopLottie1,
  } = useHoverLottie({
    animationData: jiantou,
  });
  const {
    lottieOptions: lottieOptions2,
    playLottieOnce: playLottieOnce2,
    stopLottie: stopLottie2,
  } = useHoverLottie({
    animationData: jiantou1,
  });
  return (
    <div>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          showBtn={false}
          btns={
            <Flex gap={".2rem"}>
              <div
                className={styles.p1_button}
                onMouseEnter={playLottieOnce}
                onMouseLeave={stopLottie}
                onClick={() => {
                  window.open(data.p1.btn1.link, "_blank");
                }}
              >
                {data.p1.btn1.text}
                <Lottie
                  className={styles.p1_button_lottie}
                  {...lottieOptions}
                />
              </div>
              <div
                className={styles.p1_button_2}
                onMouseEnter={playLottieOnce1}
                onMouseLeave={stopLottie1}
                onClick={() => {
                  window.open(data.p1.btn2.link, "_blank");
                }}
              >
                {data.p1.btn2.text}
                <Lottie
                  className={styles.p1_button_lottie}
                  {...lottieOptions1}
                />
              </div>
            </Flex>
          }
        />
      </div>
      <div className={styles.p2}>
          <div className={styles.p2_img}>
            <img src={p2Img} />
          </div>
        <div className={styles.p2_inner}>
          <Flex
            align="center"
            justify="space-between"
            className={styles.p2_title}
          >
            <div>
              <div>{data.p2.title}</div>
              <div className={styles.p2_subtitle}>
                <span>{data.p2.subtitle}</span>
              </div>
            </div>
            <div className={styles.p2_desc}>
              {data.p2.desc}
            </div>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <Flex gap={".2rem"}>
            {p3List.map((item, index) => (
              <P3Card
                key={index}
                title={item.title}
                list={item.list}
                icon={item.icon}
                link={item.link}
              />
            ))}
          </Flex>
        </div>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>{data.p4.title}</div>
          <Flex gap={".2rem"} wrap="wrap">
            {p4List.map((item, index) => (
              <P4Card
                key={index}
                title={item.title}
                desc={item.desc}
                tags={item.tags}
                img={item.img}
              />
            ))}
          </Flex>
        </div>
      </div>
      <div className={styles.p5}>
        <div className={styles.p5_inner}>
          <div className={styles.p5_title}>{data.p5.title}</div>
          <Flex gap={".2rem"}>
            {p5List.map((item, index) => (
              <P5Card
                key={index}
                title={item.title}
                list={item.list}
                link={item.link}
              />
            ))}
          </Flex>
        </div>
      </div>
      <div className={styles.p6}>
        <div className={styles.p6_inner}>
          <div className={styles.p6_title}>{data.p6.title}</div>
          <Flex gap={".5rem"} justify="space-between">
            {p6Steps.map((item, index) => (
              <Flex
                gap={".2rem"}
                align="center"
                key={index}
                className={styles.p6_step}
              >
                <img src={item.icon} />
                <Flex vertical gap={6}>
                  <div className={styles.p6_step_title}>{item.title}</div>
                  <div className={styles.p6_step_desc}>{item.desc}</div>
                </Flex>
                {index !== p6Steps.length - 1 && (
                  <img src={p6Arrow} className={styles.p6_step_arrow} />
                )}
              </Flex>
            ))}
          </Flex>
          <div
            className={styles.p6_btn}
            onMouseEnter={playLottieOnce2}
            onMouseLeave={stopLottie2}
            onClick={() => {
              window.open("https://aibeings-vip.xiaoice.com", "_blank");
            }}
          >
            {data.p6.btnText || "注册开发者"}
            <Lottie {...lottieOptions2} className={styles.p6_btn_lottie} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileDeveloper : Developer;
